import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { colors } from '../../theme/default/color';
import type { FilterButtonProps } from './FilterButton.types';
import { useRouterEventually } from '../../hooks';

const PREFIX = 'FilterButton';

const classes = {
  filterButtonInactive: `${PREFIX}-filterButtonInactive`,
  filterButtonActive: `${PREFIX}-filterButtonActive`,
};

const StyledButtonWrapper = styled('div')(({ theme }) => ({
  [`& .${classes.filterButtonInactive}`]: {
    '&:hover, &:focus': {
      background: 'transparent' + '!important',
      boxShadow: `inset 0px 0px 0px 2px ${theme.palette.raspberryColors?.PLUS_1}`,
      color: colors.white,
      borderColor: theme.palette.raspberryColors?.PLUS_2,
    },
  },

  [`& .${classes.filterButtonActive}`]: {
    background: theme.palette.raspberryColors?.PLUS_1,
    boxShadow: 'none',
    color: colors.white + '!important',
  },
}));

export const FilterButton: React.FC<FilterButtonProps> = ({
  value,
  variant,
  color,
  className,
  labelAdditional,
  onClick,
}) => {
  const router = useRouterEventually();
  const filter = (router?.query?.filter as string) || '';
  const [isSeletcted, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(value.trim().toLowerCase() === filter.trim().toLowerCase());
  }, [router, filter]);

  const onClickHandle = () => onClick(value);

  const currentClassName = isSeletcted
    ? classes.filterButtonActive
    : classes.filterButtonInactive;

  return (
    <StyledButtonWrapper>
      <Button
        variant={variant}
        color={color}
        aria-label={labelAdditional || ''}
        onClick={onClickHandle}
        className={clsx(className, currentClassName)}>
        {value}
      </Button>
    </StyledButtonWrapper>
  );
};
